const language = () => {
  const links = document.querySelectorAll(".language-link");
  for (const link of links) {
    const content = link.textContent;
    if (content.length === 2) {
      link.innerHTML = `<span>${content}</span><span>${content}</span>`;
    }
  }
};

export default language;
